import { GridLocaleText } from '@mui/x-data-grid-pro';

// ----------------------------------------------------------------

export const GRID_LV_LOCALE_TEXT: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Nav rindu',
  noResultsOverlayLabel: 'Rezultāti nav atrasti.',

  // Density selector toolbar button text
  toolbarDensity: 'Blīvums',
  toolbarDensityLabel: 'Blīvums',
  toolbarDensityCompact: 'Kompakts',
  toolbarDensityStandard: 'Standarta',
  toolbarDensityComfortable: 'Ērts',

  // Columns selector toolbar button text
  toolbarColumns: 'Kolonnas',
  toolbarColumnsLabel: 'Izvēlēties kolonnas',

  // Filters toolbar button text
  toolbarFilters: 'Filtri',
  toolbarFiltersLabel: 'Rādīt filtrus',
  toolbarFiltersTooltipHide: 'Paslēpt filtrus',
  toolbarFiltersTooltipShow: 'Rādīt filtrus',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktīvi filtri` : `${count} aktīvs filtrs`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Meklēt…',
  toolbarQuickFilterLabel: 'Meklēt',
  toolbarQuickFilterDeleteIconLabel: 'Notīrīt',

  // Export selector toolbar button text
  toolbarExport: 'Eksportēt',
  toolbarExportLabel: 'Eksportēt',
  toolbarExportCSV: 'Lejupielādēt kā CSV',
  toolbarExportPrint: 'Drukāt',
  toolbarExportExcel: 'Lejupielādēt kā Excel',

  // Columns management text
  columnsManagementSearchTitle: 'Meklēt',
  columnsManagementNoColumns: 'Nav kolonnu',
  columnsManagementShowHideAllText: 'Rādīt/Slēpt visas',
  columnsManagementReset: 'Atiestatīt',
  columnsManagementDeleteIconLabel: 'Notīrīt',

  // Filter panel text
  filterPanelAddFilter: 'Pievienot filtru',
  filterPanelRemoveAll: 'Noņemt visus',
  filterPanelDeleteIconLabel: 'Dzēst',
  filterPanelLogicOperator: 'Loģiskais operators',
  filterPanelOperator: 'Operators',
  filterPanelOperatorAnd: 'Un',
  filterPanelOperatorOr: 'Vai',
  filterPanelColumns: 'Kolonnas',
  filterPanelInputLabel: 'Vērtība',
  filterPanelInputPlaceholder: 'Filtra vērtība',

  // Filter operators text
  filterOperatorContains: 'satur',
  filterOperatorDoesNotContain: 'nesatur',
  filterOperatorEquals: 'vienāds ar',
  filterOperatorDoesNotEqual: 'nav vienāds ar',
  filterOperatorStartsWith: 'sākas ar',
  filterOperatorEndsWith: 'beidzas ar',
  filterOperatorIs: 'ir',
  filterOperatorNot: 'nav',
  filterOperatorAfter: 'ir pēc',
  filterOperatorOnOrAfter: 'ir šajā vai pēc šīs dienas',
  filterOperatorBefore: 'ir pirms',
  filterOperatorOnOrBefore: 'ir šajā vai pirms šīs dienas',
  filterOperatorIsEmpty: 'ir tukšs',
  filterOperatorIsNotEmpty: 'nav tukšs',
  filterOperatorIsAnyOf: 'ir viens no',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

  // Header filter operators text
  headerFilterOperatorContains: 'Satur',
  headerFilterOperatorDoesNotContain: 'Nesatur',
  headerFilterOperatorEquals: 'Vienāds ar',
  headerFilterOperatorDoesNotEqual: 'Nav vienāds ar',
  headerFilterOperatorStartsWith: 'Sākas ar',
  headerFilterOperatorEndsWith: 'Beidzas ar',
  headerFilterOperatorIs: 'Ir',
  headerFilterOperatorNot: 'Nav',
  headerFilterOperatorAfter: 'Ir pēc',
  headerFilterOperatorOnOrAfter: 'Ir šajā vai pēc šīs dienas',
  headerFilterOperatorBefore: 'Ir pirms',
  headerFilterOperatorOnOrBefore: 'Ir šajā vai pirms šīs dienas',
  headerFilterOperatorIsEmpty: 'Ir tukšs',
  headerFilterOperatorIsNotEmpty: 'Nav tukšs',
  headerFilterOperatorIsAnyOf: 'Ir viens no',
  'headerFilterOperator=': 'Vienāds ar',
  'headerFilterOperator!=': 'Nav vienāds ar',
  'headerFilterOperator>': 'Lielāks par',
  'headerFilterOperator>=': 'Lielāks vai vienāds',
  'headerFilterOperator<': 'Mazāks par',
  'headerFilterOperator<=': 'Mazāks vai vienāds',

  // Filter values text
  filterValueAny: 'jebkurš',
  filterValueTrue: 'patiess',
  filterValueFalse: 'aplams',

  // Column menu text
  columnMenuLabel: 'Izvēlne',
  columnMenuShowColumns: 'Rādīt kolonnas',
  columnMenuManageColumns: 'Pārvaldīt kolonnas',
  columnMenuFilter: 'Filtrs',
  columnMenuHideColumn: 'Slēpt kolonnu',
  columnMenuUnsort: 'Atcelt kārtošanu',
  columnMenuSortAsc: 'Kārtot augošā secībā',
  columnMenuSortDesc: 'Kārtot dilstošā secībā',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktīvi filtri` : `${count} aktīvs filtrs`,
  columnHeaderFiltersLabel: 'Rādīt filtrus',
  columnHeaderSortIconLabel: 'Kārtot',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} rindas atlasītas`
      : `${count.toLocaleString()} rinda atlasīta`,

  // Total row amount footer text
  footerTotalRows: 'Kopējais rindu skaits:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} no ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Atlase ar izvēles rūtiņu',
  checkboxSelectionSelectAllRows: 'Atlasīt visas rindas',
  checkboxSelectionUnselectAllRows: 'Noņemt visas atlases',
  checkboxSelectionSelectRow: 'Atlasīt rindu',
  checkboxSelectionUnselectRow: 'Noņemt rindas atlasi',

  // Boolean cell text
  booleanCellTrueLabel: 'jā',
  booleanCellFalseLabel: 'nē',

  // Actions cell more text
  actionsCellMore: 'vairāk',

  // Column pinning text
  pinToLeft: 'Piespraust pa kreisi',
  pinToRight: 'Piespraust pa labi',
  unpin: 'Noņemt piespraudi',

  // Tree Data
  treeDataGroupingHeaderName: 'Grupa',
  treeDataExpand: 'skatīt apakšvienības',
  treeDataCollapse: 'slēpt apakšvienības',

  // Grouping columns
  groupingColumnHeaderName: 'Grupa',
  groupColumn: (name) => `Grupēt pēc ${name}`,
  unGroupColumn: (name) => `Pārtraukt grupēšanu pēc ${name}`,

  // Master/detail
  detailPanelToggle: 'Detalizētā paneļa pārslēgšana',
  expandDetailPanel: 'Izvērst',
  collapseDetailPanel: 'Sakļaut',

  // Used core components translation keys
  MuiTablePagination: {
    labelRowsPerPage: 'Rindas lapā:',
    labelDisplayedRows: ({ from, to, count, estimated }) => {
      if (!estimated) {
        return `${from}–${to} no ${count !== -1 ? count : `vairāk nekā ${to}`}`;
      }
      const estimatedLabel =
        estimated && estimated > to ? `aptuveni ${estimated}` : `vairāk nekā ${to}`;
      return `${from}–${to} no ${count !== -1 ? count : estimatedLabel}`;
    },
    getItemAriaLabel: (type) => {
      if (type === 'first') {
        return 'Atgriezties pirmajā lapā';
      }
      if (type === 'last') {
        return 'Atgriezties pēdējā lapā';
      }
      if (type === 'next') {
        return 'Atgriezties nākamajā lapā';
      }
      // if (type === 'previous') {
      return 'Atgriezties iepriekšējā lapā';
    },
  },

  // Row reordering text
  rowReorderingHeaderName: 'Rindu pārkārtošana',

  // Aggregation
  aggregationMenuItemHeader: 'Agregācija',
  aggregationFunctionLabelSum: 'summa',
  aggregationFunctionLabelAvg: 'vidējais',
  aggregationFunctionLabelMin: 'min',
  aggregationFunctionLabelMax: 'maks',
  aggregationFunctionLabelSize: 'izmērs',
};
